import { render, staticRenderFns } from "./MaterialPurchase.vue?vue&type=template&id=083b7b08&"
import script from "./MaterialPurchase.vue?vue&type=script&lang=js&"
export * from "./MaterialPurchase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports